import React, { useState } from 'react';
import './DeleteStoreModal.css';

const DeleteStoreModal = ({ store, onConfirm, onCancel }) => {
  const [confirmText, setConfirmText] = useState('');

  const isMatch = confirmText === store.name;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isMatch) {
      onConfirm();
    }
  };

  return (
    <div className="dsm-overlay" onClick={onCancel}>
      <div className="dsm-modal" onClick={e => e.stopPropagation()}>
        <div className="dsm-header">
          <h2>Delete Store Permanently</h2>
          <button className="dsm-close" onClick={onCancel}>&times;</button>
        </div>

        <div className="dsm-body">
          <div className="dsm-warning">
            This action <strong>cannot be undone</strong>. This will permanently delete the
            store, all its categories, and all its products.
          </div>

          <div className="dsm-store-name">
            {store.name}
          </div>

          <form onSubmit={handleSubmit}>
            <label className="dsm-label">
              Type <strong>{store.name}</strong> to confirm:
            </label>
            <input
              type="text"
              className="dsm-input"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type the store name exactly"
              autoFocus
            />
            <div className="dsm-actions">
              <button type="button" className="dsm-btn dsm-btn-cancel" onClick={onCancel}>
                Cancel
              </button>
              <button
                type="submit"
                className="dsm-btn dsm-btn-delete"
                disabled={!isMatch}
              >
                Delete Store
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteStoreModal;
